import { render, staticRenderFns } from "./TopicViewer.vue?vue&type=template&id=27fd0670&scoped=true&"
import script from "./TopicViewer.vue?vue&type=script&lang=js&"
export * from "./TopicViewer.vue?vue&type=script&lang=js&"
import style0 from "./TopicViewer.vue?vue&type=style&index=0&id=27fd0670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd0670",
  null
  
)

export default component.exports